import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTriggerAcc
} from '@/components/common/Tabs';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/hooks/useStore';
import { FORM_TYPE, FormType } from '@/types/enums';
import BasicInformation from './BasicInformation';
import BikesRegistedLocation from './BikesRegistedLocation';

interface LocationScreenProps {
    formType: FormType
}

export default observer(function AddNewLocation({
    formType
}: LocationScreenProps) {
    // hook
    const { t } = useTranslation();

    // store
    const {
        locationStore: { location, setObservable }
    } = useStore();

    // state
    const [activeTab, setActiveTab] = useState<string>('basic');

    // lifecycle
    useEffect(() => {
        return () => {
            setObservable('location', undefined);
        };
    }, []);

    // function
    // handle change tab add new location
    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    return (
        <div>
            <Tabs
                value={activeTab}
                onValueChange={handleTabChange}
                className='w-full'
            >
                <TabsList className='grid w-full gap-1.5 grid-cols-4'>
                    <TabsTriggerAcc value='basic'>
                        {t('words_title.basic_info')}
                    </TabsTriggerAcc>
                    <TabsTriggerAcc
                        value='bike-list'
                        disabled={formType === FORM_TYPE.Create && !location}
                    >
                        {t('words_title.bike_list')}
                    </TabsTriggerAcc>
                </TabsList>
                <TabsContent value='basic' className='mt-0'>
                    <BasicInformation formType={formType} />
                </TabsContent>
                <TabsContent value='bike-list' className='mt-0'>
                    <BikesRegistedLocation />
                </TabsContent>
            </Tabs>
        </div>
    );
});
